import React from 'react';
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-charcoal-900 text-cream-200 pt-16 pb-8" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-20">
          {/* Brand */}
          <div className="space-y-6" data-id="element-21">
            <img src="https://www.downhomeinteriors.com/uploaded/images/newresponsivesite/header/logo.png" alt="Down Home Interiors" className="h-12 w-auto brightness-0 invert opacity-90" data-id="element-22" />
            <p className="text-cream-200/70 text-sm leading-relaxed max-w-xs" data-id="element-23">
              Creating timeless, elegant spaces that feel like home. Visit our
              showroom or book a consultation.
            </p>
            <div className="flex space-x-4" data-id="element-24">
              <a href="https://www.facebook.com/DownTowneApparel/" target="_blank" rel="noopener noreferrer" className="text-cream-200 hover:text-sage-500 transition-colors" aria-label="Facebook" data-id="element-25">
                <Facebook size={20} data-id="element-26" />
              </a>
              <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" className="text-cream-200 hover:text-sage-500 transition-colors" aria-label="Instagram" data-id="element-27">
                <Instagram size={20} data-id="element-28" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-29">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-30">Explore</h3>
            <ul className="space-y-3" data-id="element-31">
              <li data-id="element-32">
                <Link to="/about" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-33">
                  Our Story
                </Link>
              </li>
              <li data-id="element-34">
                <Link to="/portfolio" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-35">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/services" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-37">
                  Services
                </Link>
              </li>
              <li data-id="element-38">
                <Link to="/testimonials" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-39">
                  Testimonials
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-40">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-41">Contact</h3>
            <ul className="space-y-4" data-id="element-42">
              <li className="flex items-start space-x-3 text-cream-200/70" data-id="element-43">
                <MapPin size={18} className="mt-1 flex-shrink-0" data-id="element-44" />
                <span data-id="element-45">
                  2729 E. Grand River Ave.
                  <br data-id="element-46" />
                  Howell, MI 48843
                </span>
              </li>
              <li className="flex items-center space-x-3 text-cream-200/70" data-id="element-47">
                <Phone size={18} data-id="element-48" />
                <span data-id="element-49">(555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-3 text-cream-200/70" data-id="element-50">
                <Mail size={18} data-id="element-51" />
                <span data-id="element-52">hello@downhomeinteriors.com</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-53">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-54">
              Showroom Hours
            </h3>
            <ul className="space-y-2 text-cream-200/70" data-id="element-55">
              <li className="flex justify-between" data-id="element-56">
                <span data-id="element-57">Mon - Fri</span>
                <span data-id="element-58">10am - 6pm</span>
              </li>
              <li className="flex justify-between" data-id="element-59">
                <span data-id="element-60">Saturday</span>
                <span data-id="element-61">10am - 4pm</span>
              </li>
              <li className="flex justify-between" data-id="element-62">
                <span data-id="element-63">Sunday</span>
                <span data-id="element-64">Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-charcoal-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-cream-200/40" data-id="element-65">
          <p data-id="element-66">
            &copy; {new Date().getFullYear()} Down Home Interiors. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-67">
            <span className="hover:text-cream-200 cursor-pointer" data-id="element-68">
              Privacy Policy
            </span>
            <span className="hover:text-cream-200 cursor-pointer" data-id="element-69">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}